import React, { useEffect } from "react";
import { useI18n } from "@/lib/i18n";
import PageTitle from "@/components/PageTitle";

const PrivacyPage = () => {
  const { t } = useI18n();
  useEffect(() => {
    document.title = t("pageTitles.privacy");
  }, [t]);

  const SECTIONS = ["data", "purposes", "basis", "retention", "rights", "security", "transfers"];

  return (
    <main data-testid="privacy-page" className="bg-white">
      <PageTitle
        title={t("privacy.title")}
        subtitle={t("pageHeader.privacySubtitle")}
        breadcrumbKey="privacy"
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <p className="text-sm text-slate-500">{t("privacy.updated")}</p>
        <p className="mt-6 text-base text-slate-700 leading-relaxed">
          {t("privacy.intro")}
        </p>

        <div className="mt-10 space-y-10">
          {SECTIONS.map((key) => (
            <section key={key} data-testid={`privacy-section-${key}`}>
              <h2 className="font-heading text-xl sm:text-2xl font-semibold text-slate-900">
                {t(`privacy.sections.${key}.title`)}
              </h2>
              {key === "purposes" ? (
                <ul className="mt-3 space-y-2 list-disc pl-5 text-slate-700">
                  {["reports", "communication", "improvement"].map((i) => (
                    <li key={i} className="leading-relaxed">
                      {t(`privacy.sections.purposes.items.${i}`)}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="mt-3 text-base text-slate-700 leading-relaxed">
                  {t(`privacy.sections.${key}.body`)}
                </p>
              )}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
};

export default PrivacyPage;
